import { render, staticRenderFns } from "./raw-data.vue?vue&type=template&id=5f79c874&"
import script from "./raw-data.vue?vue&type=script&lang=js&"
export * from "./raw-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports